import { trackPageView } from 'utils/thirdPartyTags';

const pageTrackerMiddleware = ({ getState, dispatch }) => {
	return next => action => {
		// The landing page's view is already sent by the Google tag's config in public/index.html.
		if (action.type === '@@router/LOCATION_CHANGE' && !action?.payload?.isFirstRendering) {
			trackPageView(action?.payload?.location?.pathname);
		}
		return next(action);
	}
}

export default pageTrackerMiddleware;